module.exports = __webpack_public_path__ + "img/check-icon.0af80139.svg";